module.exports = __webpack_public_path__ + "img/30.f603588b.svg";